import React, { useState, useEffect } from 'react'
import { questionsAndChoices, findQuestion, updateAnswers, nextRoute } from './constants'
import compris from '../../assests/images/001 Compris TM clr.png'
import { Container, Row, Col, Label, Button, Table, FormGroup } from 'reactstrap'
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next';


function MatrixWithInputs({
    questionContent,
    questionID,
    history,
    ...props
}) {
    const [matrixSelectedIds, setMatrixSelectedState] = useState({})
    const [error, setError] = useState(false)

    const [lengthError, setLengthError] = useState(false)

    const [matrixOthers, setMatrixOthers] = useState('')
    const [questionDetails, setQuestionDetails] = useState()
    const [questionIndex, setQuestionIndex] = useState()
    const [currentQuestionNumber, setCurrentQuestionNumber] = useState()
    const [update, setUpdate] = useState(false)
    const [previouslyFilledAnswers, setPreviouslyFilledAnswers] = useState([])

    const { t, i18n } = useTranslation();

    useEffect(()=>{
        const allquestions = JSON.parse(JSON.stringify(questionsAndChoices))
        const {question, currentQuestionIndex} = findQuestion(allquestions, questionID)
        setQuestionIndex(currentQuestionIndex)
        updateQuestionDetails(question, questionContent, questionID)
    }, [questionID])

    const updateQuestionDetails = (question, previousAnswers, currentQuestionId) => {
        if(questionID == 555422217){
            let choices = []
            question.fields.containsOther = false
            let questionNo26Answer = previousAnswers.questions?previousAnswers.questions.find(item => item.id == 580243889).answers:[]
            let tobaccoAdded = false
            questionNo26Answer.forEach(item => {
                if(!tobaccoAdded && (item.choice_id == 3821196634 || item.choice_id == 3983757573)){
                    tobaccoAdded = true
                    choices.push(question.fields.choices[0])
                }
                else if(item.choice_id == 3821196620){
                    choices.push(question.fields.choices[1])
                }
                else if(item.choice_id == 3821196621){
                    choices.push(question.fields.choices[2])
                }
                else if(item.choice_id == 3821196622){
                    choices.push(question.fields.choices[3])
                }
                else if(item.choice_id == 3821196623){
                    choices.push(question.fields.choices[4])
                }
                else if(item.choice_id == 3821196624){
                    choices.push(question.fields.choices[6])
                }
                else if(item.choice_id == 3821196625){
                    choices.push(question.fields.choices[5])
                }
                else if(item.choice_id == 3821196626){
                    choices.push(question.fields.choices[7])
                }
                else if(item.choice_id == 3821196627){
                    choices.push(question.fields.choices[8])
                }
                else if(item.choice_id == 3821196628){
                    choices.push(question.fields.choices[9])
                }
                else if(item.choice_id == 3821196633){
                    choices.push(question.fields.choices[11])
                }
                else if(item.choice_id == 3821196629){
                    choices.push(question.fields.choices[10])
                }
                else if(item.choice_id == 3821196630){
                    choices.push(question.fields.choices[12])
                }
                else if(item.choice_id == 3821196631){
                    choices.push(question.fields.choices[13])
                }
                else if(item.other_id == 3821196643){
                    question.fields.containsOther = true
                    choices.push(question.fields.choices[14])
                }
            })
            if(choices[0]){
                question.fields.choices = choices
            }
            else{
                history.push(`/questions/3622508801`)
            }
        }
        setQuestionDetails({...question})
        prefillValues(question)
    }

    const prefillValues = (questionDetails) => {
        let index = questionContent.questions?questionContent.questions.findIndex(item => item.id == questionID):-1
        if(index!=-1){
            setUpdate(true)
            setCurrentQuestionNumber(index+1)
            setPreviouslyFilledAnswers(questionContent.questions[index].answers)
            let answers = {}
            questionDetails.fields.rowText.forEach((item, i) => {
                questionDetails.fields.choices.forEach((data) =>{
                    questionContent.questions[index].answers.forEach((elem) => {
                        if(data.row_id == elem.row_id && elem.choice_id == item.id){
                            answers[`${data.choice_text} ${item.text}`] = elem
                        }
                    })
                })
            })
            setMatrixSelectedState(answers)
        }
        else if(questionContent.questions){
            for(let i=questionContent.questions.length-1; i>=0; i--){
                const {currentQuestionIndex} = findQuestion(questionsAndChoices, questionContent.questions[i].id)
                if(questionsAndChoices[currentQuestionIndex].pk < questionDetails.pk){
                    if(i == questionContent.questions.length-1)
                        setCurrentQuestionNumber(i+2)
                    else
                        setCurrentQuestionNumber(i+2)
                    break;
                }
            }
        }
    }

    const matrixOnChange = (value, name, row_id, choice_id) => {
        let matrixSelectedIdsCopy = {...matrixSelectedIds}
        matrixSelectedIdsCopy[name] = {
            row_id,
            choice_id,
            text: value
        }
        setMatrixSelectedState(matrixSelectedIdsCopy)
    }
    
    
    const nextPage = () => {        
        const matrixCopy = [...Object.values(matrixSelectedIds)]
            function checkAllInputAnswered(arr){
                let count = 0
                arr.forEach(item => {
                    if(item.text){
                        ++count
                    }
                })
               return questionDetails.fields.choices.length*3 == count 
            }

            if(checkAllInputAnswered(matrixCopy)){
                    setError(false)
                    setLengthError(false)
                    let questionContentCopy = JSON.parse(JSON.stringify(questionContent))
                    setUpdate(false)
                    nextRoute(questionContentCopy, questionID, history, matrixCopy, questionIndex)
                    setMatrixOthers('')
                    updateAnswers(questionContentCopy, currentQuestionNumber, {
                        id: questionID,
                        answers: matrixCopy
                    }, update)
                    props.dispatch({
                        type: `UPDATE_CONTENT`,
                        payload: questionContentCopy
                    }, setMatrixSelectedState([]))
            }
            else{
                setError(true)
            }
    }

    const prevPage = () => {
        setError(false)
        if(questionIndex === 14){
            history.push(`/questions/page4`)
        }
        else{
            // history.push(`/questions/${questionsAndChoices[questionIndex-1].fields.question_id}`)
            let index = questionContent.questions?questionContent.questions.findIndex(item => item.id == questionID):-1
            if(index == -1){
                history.push(`/questions/${questionContent.questions[currentQuestionNumber-2].id}`)
            }
            else{
                history.push(`/questions/${questionContent.questions[index-1].id}`)
            }
        }
    }

    return (
        <Container>
            {questionDetails?<div>
                {questionDetails.fields.question_type === 'matrix' && <div className="bg-white container mb-3" style={{borderRadius: '2px'}}>
                    <div className="p-2" style={{overflow: 'auto'}}>
                        {
                            
                        }
                        <p dangerouslySetInnerHTML={{__html: `${currentQuestionNumber}. ${t(questionDetails.fields.question_text)}`}}></p>
                        <Table borderless striped>
                            <thead style={{backgroundColor: '#f9f9f9', fontSize: '12px', lineHeight: '1.25'}}>
                            <tr>
                                {questionDetails.fields.choices?<td></td>:null}
                                {questionDetails.fields.rowText.map((item, i) => <td align="center" key={i}>{t(item.text)}</td>)}
                            </tr>
                            </thead>
                            <tbody>
                                {questionDetails.fields.choices?questionDetails.fields.choices.map((item, i) => 
                                    <tr key={i}>
                                        <td>{t(item.choice_text)}</td>
                                        {questionDetails.fields.rowText.map((data, j) => <td align="center" key={j}>
                                            {data.id == 3662615714 && <Checkbox color="primary" disabled={matrixSelectedIds && matrixSelectedIds[item.choice_text + "" + ' age when likely became a problem or dependence'] && matrixSelectedIds[item.choice_text + "" + ' age when likely became a problem or dependence'].text} defaultChecked={previouslyFilledAnswers[0]?previouslyFilledAnswers.find(elem => elem.choice_id == data.id && elem.row_id == item.row_id)?Boolean(previouslyFilledAnswers.find(elem => elem.choice_id == data.id && elem.row_id == item.row_id).text): false:false} onChange={(e) => matrixOnChange(e.target.checked ? 1: 0, `${item.choice_text} ${data.text}`, item.row_id, data.id)} />}
                                            {data.id != 3662615714 && <TextField disabled={data.text == 'age when likely became a problem or dependence' && matrixSelectedIds && matrixSelectedIds[item.choice_text + "" + ' never a problem'] && matrixSelectedIds[item.choice_text + "" + ' never a problem'].text == 1} inputProps={{ maxLength: 2 }} type="tel" defaultValue={previouslyFilledAnswers[0]?previouslyFilledAnswers.find(elem => elem.choice_id == data.id && elem.row_id == item.row_id)?previouslyFilledAnswers.find(elem => elem.choice_id == data.id && elem.row_id == item.row_id).text: '':''} onChange={e => matrixOnChange(e.target.value, `${item.choice_text} ${data.text}`, item.row_id, data.id)} />}                                        </td>)}
                                    </tr>
                                ):null}
                            </tbody>
                        </Table>
                        {questionDetails.fields.containsOther && <FormGroup>
                            <Label>{t(questionDetails.fields.otherOptionText)}</Label><br />
                            <TextField style={{paddingBottom: '2%'}} name={questionDetails.fields.otherOptionText} type="text" placeholder={`${t('Type your answer..."')}`} onChange={e => setMatrixOthers(e.target.value)} />
                        </FormGroup>}
                    </div>
                </div>}
                <div className="bg-white container mb-3" style={{borderRadius: '2px'}}>
                    {lengthError && <p style={{color: 'red',padding:'10px 0'}}>{t('Please enter an age BELOW 100')}<br /></p>}
                    {error && <p style={{color: 'red',padding:'10px 0'}}>{t('Please fill in age first used, last used, and EITHER age likely became a problem OR never a problem.')}<br /></p>}
                    <div className='px-2 py-3' style={{display: 'flex', justifyContent: 'space-between'}}>
                    <p style={{fontSize: '12px', lineHeight: '1.17', color: '#afafaf',marginBottom:'0',paddingTop:'10px'}}>{t('Powered by')} <a href="https://www.compriscare.com/" target="_blank"><img src={process.env.LOGO_URI} style={{marginLeft: '10px'}} className="footer-img-logo" /></a></p>
                        <div className="button-footer-wrapper">
                            <Button style={{backgroundColor: 'transparent', color: '#5e6265', border: 'none'}} onClick={prevPage} type='button' >{t('Previous')}</Button>
                            <Button style = {{marginLeft: '10px', backgroundColor: '#055ce5', color: 'white', borderRadius: '2px', border: 'none'}} onClick={nextPage} type='button' >{t('Next')}</Button>
                        </div>
                    </div>
                </div>
            </div>:null}
        </Container>
    )
}

const mapStateToProps = state => {
    return {
        questionContent : state.question.content,
    }
}

export default connect(mapStateToProps)(MatrixWithInputs)
